<template>
  <footer class="create-ticket-footer">
    <section class="create-ticket-footer__buttons">
      <ButtonOutline
        :buttonText="t('general__text__cancel')"
        @onClicked="emits('cancelCreateTicket')"
      />
      <ButtonPrimary
        :buttonText="`${t('general__data__create')} ${t(
          'general__data__ticket-the'
        ).toLowerCase()}`"
        :disabled="disableSaveButton"
        @onClicked="emits('createTicket')"
      />
    </section>
  </footer>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { CreateTicket } from '@/services/tickets.service'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'

interface EMITS {
  (e: 'cancelCreateTicket'): void
  (e: 'createTicket'): void
}
const emits = defineEmits<EMITS>()

const { t } = useI18n()

const formData = inject<CreateTicket>('formDataCreateErrand')

const disableSaveButton = computed(() => {
  return (
    !formData?.title.length ||
    !formData?.typeId ||
    !formData?.categoryId ||
    !formData?.status ||
    !formData?.priority
  )
})
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/mixins.scss';

.create-ticket-footer {
  align-items: center;
  display: flex;
  height: 48px;
  &__buttons {
    display: flex;
    gap: 16px;
    margin-left: auto;
  }
}
</style>
